/**
 * Health and model operations.
 */

import type { ArbiClient } from '@arbidocs/client'
import { requireData } from '../errors.js'

export async function getHealth(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/health/'), 'Failed to fetch health status')
}

export async function getHealthModels(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/health/models'), 'Failed to fetch models')
}

export async function getRemoteModels(arbi: ArbiClient) {
  return requireData(
    await arbi.fetch.GET('/v1/health/remote-models'),
    'Failed to fetch remote models'
  )
}

export async function getMcpTools(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/health/mcp-tools'), 'Failed to fetch MCP tools')
}
